<template>
  <div
    class="p-5 md:p-8 rounded-xl border shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] flex flex-col gap-5"
    data-testid="community-supply-detail"
  >
    <div class="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-4">
      <inputPrimary :modelValue="row.property" :label="$t('property.communitySupplyDetail.property')" readonly />
      <inputPrimary :modelValue="row.company" :label="$t('property.communitySupplyDetail.company')" readonly />
      <inputPrimary :modelValue="row.cups" :label="$t('property.communitySupplyDetail.cups')" readonly />
      <inputPrimary :modelValue="row.rate" :label="$t('property.communitySupplyDetail.rate')" readonly />
    </div>

    <div class="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-4">
      <inputPrimary :modelValue="row.address" :label="$t('property.communitySupplyDetail.address')" readonly />
      <inputPrimary :modelValue="row.postal_code" :label="$t('property.communitySupplyDetail.postalCode')" readonly />
      <inputPrimary :modelValue="row.municipality" :label="$t('property.communitySupplyDetail.municipality')" readonly />
      <inputPrimary :modelValue="row.province" :label="$t('property.communitySupplyDetail.province')" readonly />
    </div>

    <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4">
      <inputPrimary :modelValue="row.cif" :label="$t('property.communitySupplyDetail.cif')" readonly />
      <inputPrimary :modelValue="row.iban" :label="$t('property.communitySupplyDetail.iban')" readonly />
      <inputPrimary
        :modelValue="row.contract_expiration"
        :label="$t('property.communitySupplyDetail.contractExpiration')"
        readonly
        data-testid="community-contract-expiration"
      />
    </div>

    <div v-if="type === 'light'" data-testid="community-supply-powers">
      <p class="text-[#385660] mb-2">{{ $t('property.communitySupplyDetail.powers') }}</p>
      <ul class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2 rounded-md p-3 text-sm border shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]">
        <li v-for="period in POWER_PERIODS" :key="period">
          <span class="font-semibold">{{ period.toUpperCase() }}:</span>
          <span class="text-[#7CADB9]"> {{ row.powers[period] }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import inputPrimary from '@/components/inputs/input-primary.vue'
import { POWER_PERIODS } from '@/constants/supplyRates'
import { communitySupplyDetail } from '@/services/communitySupplyDetails'

const props = defineProps({
  supply: { type: Object, required: true },
  type: { type: String, required: true, validator: (value) => ['light', 'gas'].includes(value) },
})

const { t } = useI18n()
const row = computed(() => communitySupplyDetail(props.supply, t('property.communitySupplyDetail.pendingContract')))
</script>
